import { ReduxSimpleActionInterface } from '@ecommerce/nest-ssr/dist/common';

export enum ModalsActions {
    OpenModal = 'OPEN_MODAL',
    CloseModal = 'CLOSE_MODAL'
}

export interface ModalsState {
    openedModal: string | null;
}

export const modals = [
    (
        state: ModalsState,
        action: ReduxSimpleActionInterface<ModalsActions, { payload: { openedModal: string | null; }; }>
    ): ModalsState => {
        switch (action.type) {
            case ModalsActions.OpenModal:
                return { ...state, openedModal: action.payload.openedModal };
            case ModalsActions.CloseModal:
                return { ...state, openedModal: null };

            default:
                return state;
        }
    }
];
